(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-brand-collections"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__lpBrandCol){return;}
  window.__lpBrandCol=1;

  function syncNav(track){
    var car=track.closest('.lp-bcar');
    if(!car){return;}
    var prev=car.querySelector('.lp-bcar__nav--prev');
    var next=car.querySelector('.lp-bcar__nav--next');
    var max=track.scrollWidth-track.clientWidth-2;
    if(prev){prev.disabled=track.scrollLeft<=2;}
    if(next){next.disabled=track.scrollLeft>=max;}
  }

  function initCarousels(root){
    Array.prototype.forEach.call(root.querySelectorAll('.lp-bcar'),function(car){
      var track=car.querySelector('.lp-btiles');
      if(!track||car.__lpCar){return;}
      car.__lpCar=1;
      var prev=car.querySelector('.lp-bcar__nav--prev');
      var next=car.querySelector('.lp-bcar__nav--next');
      function step(){
        var tile=track.querySelector('.lp-btile');
        if(!tile){return track.clientWidth;}
        var gap=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap||'20')||20;
        var per=Math.max(1,Math.floor(track.clientWidth/(tile.offsetWidth+gap)));
        return (tile.offsetWidth+gap)*per;
      }
      if(prev){prev.addEventListener('click',function(){track.scrollLeft-=step();});}
      if(next){next.addEventListener('click',function(){track.scrollLeft+=step();});}
      track.addEventListener('scroll',function(){syncNav(track);},{passive:true});
      window.addEventListener('resize',function(){syncNav(track);},{passive:true});
      syncNav(track);
    });
  }

  function initSection(root){
    var btns=root.querySelectorAll('.lp-bbtn');
    var panels=root.querySelectorAll('.lp-bpanel');
    Array.prototype.forEach.call(btns,function(btn){
      btn.addEventListener('click',function(){
        var id=btn.getAttribute('data-lp-brand');
        Array.prototype.forEach.call(btns,function(b){
          var on=b===btn;
          b.classList.toggle('is-active',on);
          b.setAttribute('aria-selected',on?'true':'false');
        });
        Array.prototype.forEach.call(panels,function(p){
          p.classList.toggle('is-active',p.getAttribute('data-lp-bpanel')===id);
        });
        var active=root.querySelector('.lp-bpanel.is-active');
        if(active){
          Array.prototype.forEach.call(active.querySelectorAll('[data-lp-reveal]'),function(el){
            el.classList.add('lp-q','lp-in');
          });
          var track=active.querySelector('.lp-btiles');
          if(track){syncNav(track);}
        }
      });
    });
    initCarousels(root);
  }

  function boot(ctx){
    var scope=(ctx&&ctx.querySelectorAll)?ctx:document;
    Array.prototype.forEach.call(scope.querySelectorAll('.lp-bcol'),function(el){
      if(el.__lpInit){return;}
      el.__lpInit=1;
      initSection(el);
    });
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot();});}else{boot();}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-brand-lines"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__lpBrandLines3){return;}
  window.__lpBrandLines3=1;

  var cache={};

  function sync(track){
    var car=track.closest('.lp-blc');
    if(!car){return;}
    var prev=car.querySelector('.lp-blc__nav--prev');
    var next=car.querySelector('.lp-blc__nav--next');
    var span=track.scrollWidth-track.clientWidth;
    if(prev){prev.disabled=track.scrollLeft<=2;}
    if(next){next.disabled=track.scrollLeft>=span-2;}
    var can=track.scrollWidth>track.clientWidth+4;
    car.classList.toggle('lp-blc--can',can);
    var thumb=car.querySelector('.lp-blc__thumb');
    if(thumb&&can){
      var vis=track.clientWidth/track.scrollWidth;
      thumb.style.width=(vis*100)+'%';
      var frac=span>0?track.scrollLeft/span:0;
      thumb.style.transform='translateX('+(((1-vis)/vis)*100*frac)+'%)';
    }
  }

  function initCar(car){
    var track=car.querySelector('.lp-blc__track');
    if(!track||car.__lpCar){return;}
    car.__lpCar=1;
    function step(){
      var card=track.querySelector('.lp-ccard');
      if(!card){return track.clientWidth;}
      var gap=parseFloat(getComputedStyle(track).columnGap||'12')||12;
      var per=Math.max(1,Math.floor(track.clientWidth/(card.offsetWidth+gap)));
      return (card.offsetWidth+gap)*per;
    }
    var prev=car.querySelector('.lp-blc__nav--prev');
    var next=car.querySelector('.lp-blc__nav--next');
    if(prev){prev.addEventListener('click',function(){track.scrollLeft-=step();});}
    if(next){next.addEventListener('click',function(){track.scrollLeft+=step();});}
    track.addEventListener('scroll',function(){sync(track);},{passive:true});
    window.addEventListener('resize',function(){sync(track);},{passive:true});
    sync(track);
  }

  /* Fetch one line's cards and keep only this section's channel.
     Plain GET: an Accept: application/json header makes Shopify drop
     `sections=` and return the collection JSON instead - see the file note. */
  function fetchLine(url,chan){
    var key=url+'|'+chan;
    if(cache[key]){return Promise.resolve(cache[key]);}
    var sep=url.indexOf('?')>-1?'&':'?';
    return fetch(url+sep+'sections=lp-line-products')
      .then(function(r){if(!r.ok){throw new Error(r.status);}return r.json();})
      .then(function(d){
        var doc=new DOMParser().parseFromString(d['lp-line-products']||'','text/html');
        var html='',n=0;
        Array.prototype.forEach.call(doc.querySelectorAll('.lp-lp__i'),function(w){
          var v=(w.getAttribute('data-v')||'').toUpperCase();
          if(chan&&v.indexOf(chan)<0){return;}
          var card=w.querySelector('.lp-ccard');
          if(card){html+=card.outerHTML;n++;}
        });
        cache[key]={html:html,n:n};
        return cache[key];
      });
  }

  function openLine(panel,btn,chan){
    Array.prototype.forEach.call(panel.querySelectorAll('[data-lp-line]'),function(b){
      var on=b===btn;
      b.classList.toggle('is-active',on);
      b.setAttribute('aria-pressed',on?'true':'false');
    });
    var car=panel.querySelector('[data-lp-linecar]');
    var track=panel.querySelector('[data-lp-linetrack]');
    var state=panel.querySelector('[data-lp-lstate]');
    var all=panel.querySelector('[data-lp-lineall]');
    var url=btn.getAttribute('data-lp-line');
    var name=btn.getAttribute('data-lp-name');
    panel.__lpWant=url;
    if(all){
      all.href=url;
      var lbl=all.querySelector('span');
      if(lbl){lbl.textContent=(all.getAttribute('data-base')||'View all')+' '+name;}
    }
    function empty(){
      car.hidden=true;
      var note=panel.getAttribute('data-lp-note');
      state.textContent=(panel.getAttribute('data-lp-soon')||'Arriving soon')+(note?' — '+note:'');
      state.hidden=false;
      if(all){all.hidden=true;}
    }
    if(btn.getAttribute('data-lp-n')==='0'){empty();return;}
    state.textContent=state.getAttribute('data-loading')||'Loading';
    state.hidden=false;
    car.hidden=true;
    fetchLine(url,chan).then(function(res){
      if(panel.__lpWant!==url){return;}          /* a later press won */
      if(!res.n){empty();return;}
      track.innerHTML=res.html;
      car.classList.toggle('lp-blc--one',res.n<=4);
      state.hidden=true;
      car.hidden=false;
      if(all){all.hidden=false;}
      track.scrollLeft=0;
      initCar(car);
      sync(track);
    }).catch(function(){
      if(panel.__lpWant!==url){return;}
      state.innerHTML='Could not load this line. <a href="'+url+'">Open it on its own page</a>.';
      state.hidden=false;
    });
  }

  function prime(panel,chan){
    if(!panel||panel.__lpPrimed){return;}
    var first=panel.querySelector('[data-lp-line].is-active')||panel.querySelector('[data-lp-line]');
    if(!first){return;}
    panel.__lpPrimed=1;
    openLine(panel,first,chan);
  }

  function init(root){
    var chan=(root.getAttribute('data-lp-chan')||'').toUpperCase();
    var pills=root.querySelectorAll('[data-lp-bltab]');
    var panels=root.querySelectorAll('[data-lp-blpanel]');
    Array.prototype.forEach.call(pills,function(pill){
      pill.addEventListener('click',function(){
        var id=pill.getAttribute('data-lp-bltab');
        Array.prototype.forEach.call(pills,function(p){
          var on=p===pill;
          p.classList.toggle('is-active',on);
          p.setAttribute('aria-selected',on?'true':'false');
        });
        var shown=null;
        Array.prototype.forEach.call(panels,function(pl){
          var on=pl.getAttribute('data-lp-blpanel')===id;
          pl.classList.toggle('is-active',on);
          if(on){shown=pl;}
        });
        prime(shown,chan);
        var t=shown&&shown.querySelector('.lp-blc:not([hidden]) .lp-blc__track');
        if(t){sync(t);}
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-lp-line]'),function(btn){
      btn.addEventListener('click',function(){openLine(btn.closest('[data-lp-blpanel]'),btn,chan);});
    });
    Array.prototype.forEach.call(root.querySelectorAll('.lp-blc:not([data-lp-linecar])'),initCar);
    prime(root.querySelector('.lp-bl__panel.is-active'),chan);
  }

  function boot(ctx){
    var scope=(ctx&&ctx.querySelectorAll)?ctx:document;
    Array.prototype.forEach.call(scope.querySelectorAll('.lp-bl'),function(el){
      if(el.__lpBl3){return;}
      el.__lpBl3=1;
      init(el);
    });
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot();});}else{boot();}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-tabbed-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.__lpTabs){return;}
  window.__lpTabs=1;

  function initSection(root){
    var pills=root.querySelectorAll('.lp-pill');
    var panels=root.querySelectorAll('.lp-panel');
    Array.prototype.forEach.call(pills,function(pill){
      pill.addEventListener('click',function(){
        var id=pill.getAttribute('data-lp-tab');
        Array.prototype.forEach.call(pills,function(p){
          var on=p===pill;
          p.classList.toggle('is-active',on);
          p.setAttribute('aria-selected',on?'true':'false');
        });
        Array.prototype.forEach.call(panels,function(pl){
          pl.classList.toggle('is-active',pl.getAttribute('data-lp-panel')===id);
        });
        var active=root.querySelector('.lp-panel.is-active .lp-car__track');
        if(active){syncNav(active);}
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('.lp-car'),function(car){
      var track=car.querySelector('.lp-car__track');
      var prev=car.querySelector('.lp-car__nav--prev');
      var next=car.querySelector('.lp-car__nav--next');
      if(!track){return;}
      function step(){
        var card=track.querySelector('.lp-ccard');
        if(!card){return track.clientWidth;}
        var gap=parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap||'16')||16;
        var per=Math.max(1,Math.floor(track.clientWidth/(card.offsetWidth+gap)));
        return (card.offsetWidth+gap)*per;
      }
      if(prev){prev.addEventListener('click',function(){track.scrollLeft-=step();});}
      if(next){next.addEventListener('click',function(){track.scrollLeft+=step();});}
      track.addEventListener('scroll',function(){syncNav(track);},{passive:true});
      window.addEventListener('resize',function(){syncNav(track);},{passive:true});
      syncNav(track);
    });
  }

  function syncNav(track){
    var car=track.closest('.lp-car');
    if(!car){return;}
    var prev=car.querySelector('.lp-car__nav--prev');
    var next=car.querySelector('.lp-car__nav--next');
    var max=track.scrollWidth-track.clientWidth-2;
    if(prev){prev.disabled=track.scrollLeft<=2;}
    if(next){next.disabled=track.scrollLeft>=max;}

    /* the cue: only shown when the track really does overflow */
    var can=track.scrollWidth>track.clientWidth+4;
    car.classList.toggle('lp-car--can',can);
    var thumb=car.querySelector('.lp-car__thumb');
    if(thumb&&can){
      var vis=track.clientWidth/track.scrollWidth;
      thumb.style.width=(vis*100)+'%';
      var span=track.scrollWidth-track.clientWidth;
      var frac=span>0?track.scrollLeft/span:0;
      thumb.style.transform='translateX('+(((1-vis)/vis)*100*frac)+'%)';
      if(track.scrollLeft>4){car.classList.add('lp-car--moved');}
    }
  }

  function boot(ctx){
    var scope=(ctx&&ctx.querySelectorAll)?ctx:document;
    Array.prototype.forEach.call(scope.querySelectorAll('.lp-tabsec'),function(el){
      if(el.__lpInit){return;}
      el.__lpInit=1;
      initSection(el);
    });
  }

  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot();});}else{boot();}
  document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
